import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { DynamicCalltrackingLink, EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';

import * as styles from './CallBuilder.css';

export interface ICallBuilderProps {
  phone: string;
  placeType?: string;
  siteBlockId?: number | null;
  trackAction(): void;
}

export const CallBuilder: React.VFC<ICallBuilderProps> = ({
  phone,
  placeType = 'CallBuilder',
  siteBlockId,
  trackAction,
}) => {
  return (
    <DynamicCalltrackingLink
      onClick={trackAction}
      phone={phone}
      blockId={siteBlockId}
      platformType={EPlatformTypes.WebMobile}
      pageType={EPageTypes.NewbuildingCard}
      className={styles['button']}
      placeType={placeType}
    >
      <UIText1 color={'text-inverted-default'} fontWeight={'bold'} data-testid="CallText">
        Позвонить
      </UIText1>
    </DynamicCalltrackingLink>
  );
};
